module.exports = __webpack_public_path__ + "static/img/2_10.1f3a9578.jpg";